import { useTranslation } from 'i18n';
import { MenuItem, Select, SelectChangeEvent, Stack } from 'ui';

type RepresentativeType = 'Best' | 'Typical' | 'Worst';

type Props = {
  value: RepresentativeType;
  onChange: (value: RepresentativeType) => void;
};

export const RepresentativeEvidenceFilter = ({ value, onChange }: Props) => {
  const { t } = useTranslation('features');
  const handleChange = (e: SelectChangeEvent) => {
    const newValue = e.target.value;
    if (newValue === 'Best' || newValue === 'Typical' || newValue === 'Worst') {
      onChange(newValue);
    }
  };

  return (
    <Stack>
      <Select
        id="representative-evidence-ids"
        name="representative_evidence_ids"
        size="small"
        label={t('backlog.breakdowns.representativeEvidenceFilter.label')}
        value={value}
        onChange={handleChange}
      >
        <MenuItem value="Best">{t('backlog.breakdowns.representativeEvidenceFilter.options.bestBales')}</MenuItem>
        <MenuItem value="Typical">{t('backlog.breakdowns.representativeEvidenceFilter.options.typicalBales')}</MenuItem>
        <MenuItem value="Worst">{t('backlog.breakdowns.representativeEvidenceFilter.options.worstBales')}</MenuItem>
      </Select>
    </Stack>
  );
};
